import React, { useState, useContext } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ThemeContext } from "../theme/ThemeProvider"; // Import Theme Context
import { Brightness4, Brightness7 } from "@mui/icons-material"; // Theme Icons
import logo from "../assets/mis copy.jpg";

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { mode, toggleTheme } = useContext(ThemeContext); // Dark mode toggle

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setDrawerOpen(open);
  };

  const navLinks = [
    { title: "Home", path: "/" },
    { title: "About", path: "/about" },
    { title: "Services", path: "/services" },
    { title: "Contact", path: "/contact" }
    /*{ title: "Login", path: "/login" },}*/
  ];

  return (
    <AppBar position="sticky" sx={{ bgcolor: "primary.main", transition: "background-color 0.3s" }}>
      <Toolbar>
        {/* Logo and Title */}
        <Box
          sx={{
            flexGrow: 2,
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            mt: 1,
          }}
        >
          {/* Logo */}
          <a href="/" style={{ display: "flex", alignItems: "center" }}>
            <img
              src={logo}
              alt="Company Logo"
              style={{
                height: "100px",
                marginTop: "3px",
                marginBottom: "10px",
              }}
            />
          </a>

          {/* Text block (stacked vertically) */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              marginLeft: "40px",
              textAlign: "center"
            }}
          >
            <Box textAlign="center">
              <Typography
                variant="h5"
                gutterBottom={false}
                sx={{
                  mb: 0.5, // small gap
                  fontSize: {
                    xs: "h6.fontSize",
                    sm: "h4.fontSize",
                    md: "h4.fontSize",
                  },
                  fontWeight: "bold",
                  position: "relative",
                  /*display: "inline-block",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    height: "2px",
                    backgroundColor: "#1A3C7B",
                    boxShadow: "0 3px 0 #1A3C7B",
                  },*/
                }}
              >
                MAXIMUS INTEGRATED SERVICES
              </Typography>

              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: {
                    xs: "0.9rem",
                    sm: "1.1rem",
                    md: "1.2rem",
                  },
                  fontWeight: "bold",
                  color: "#3A9C36",
                  mt: -1, // tight gap
                }}
              >
                (Delivering results that endure)
              </Typography>
            </Box>

          </Box>
        </Box>



        {/* Desktop Navigation Links */}
        {!isMobile ? (
          <Box>
            {navLinks.map((link) => (
              <Button
                key={link.title}
                component={Link}
                to={link.path}
                color="secondary"
                sx={{
                  mx: 1,
                  color: "primary.contrastText",
                  "&:hover": { color: "secondary.main" },
                }}
              >
                {link.title}
              </Button>
            ))}
          </Box>
        ) : (
          // Mobile Menu Button
          <IconButton color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
            <MenuIcon />
          </IconButton>
        )}

        {/* Theme Toggle Button */}
        <IconButton
          onClick={toggleTheme}
          color="inherit"
          sx={{
            ml: 1,
            transition: "color 0.3s ease",
            "&:hover": { color: mode === "dark" ? "#FFD700" : "#1E3A8A" },
          }}
        >
          {mode === "dark" ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
      </Toolbar>

      {/* Mobile Navigation Drawer */}
      <Drawer anchor="top" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{
            width: "100%",
            bgcolor: "background.default",
            height: "auto",
            transition: "0.3s",
            paddingY: 2,
          }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List>
            {navLinks.map((link) => (
              <ListItem button key={link.title} component={Link} to={link.path}>
                <ListItemText
                  primary={link.title}
                  sx={{
                    textAlign: "center",
                    color: "text.primary",
                    fontSize: "1.2rem",
                    fontWeight: 600,
                    "&:hover": { color: "secondary.main" },
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

    </AppBar>
  );
};

export default Header;
